/* global require */
import Vue from "vue";

import { trans } from "common/translate";

export default Vue.component("publications", {
  props: [ "value" ],

  data() {
    return {
      trans
    };
  },

  template: require("./templates/publications.html"),
});





// WEBPACK FOOTER //
// ./src/frontend/pages/explore-the-archive/archive/publications.js